import { Tuple } from "components/Shared/Interfaces"

export const DEFAULT_DATE_INTERVAL = {
	currentFrom: "",
	currentTo: "",
	previousFrom: "",
	previousTo: "",
}

export const INTIAL_PARAMS = {
	departments: "0",
	categories: "0",
	subcategories: "0",
	fineline: "0",
	period: "YEAR_PRESET",
	vendors: "",
	brands: "",
	products: "",
	region: "",
	county: "",
	store: "",
	formats: "",
	metricName: "sales",
	interval: "weekly",
	channel: "",
}

export const LEVEL_NAME_DEFAULT = "department"

export type LevelName =
	| "department"
	| "category"
	| "subcategory"
	| "fineline"
	| "channels"
	| "brands"
	| "formats"
	| "region"
	| "county"
	| "item"
	| "store"

export type FilterLevelSelected = {
	filterLevelSelected: string
	selectedFilters: Array<Tuple>
}

export const VSM_METRIC_NAME = "vsm_transactions"
export const INDEX_RATE = "spending_rate"
